import React from "react";

import Lamina12act1 from "../images/lamina12act1.png";
import Lamina12act2 from "../images/lamina12act2.png";
import Lamina12act3 from "../images/lamina12act3.png";
import ActividadDesktop from "../images/lamina12actrelacion.png";
import ActividadMobile from "../images/lamina12actrelacionm.png";
import Dialog from "../images/lamina12text.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  blue: {
    color: theme.palette.blue.main,
    borderColor: theme.palette.blue.main,
  },
  rectangleYellow: {
    backgroundColor: "#ffcb05",
    padding: "20px 1em",
    transform: "rotate(-5deg)",
    "& h3, p": {
      margin: 0,
    },
    "& h3": {
      color: theme.palette.blue.main,
    },
  },
  rectangleGreen: {
    backgroundColor: "#abd037",
    padding: "1em",
    transform: "rotate(5deg)",
    "& h3, p": {
      margin: 0,
    },
    "& h3": {
      color: theme.palette.blue.main,
    },
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina11 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 12: Derechos y deberes de los ciudadanos"
        meta={[
          {
            property: "og:title",
            content: "Lámina 12: Derechos y deberes de los ciudadanos",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Todos los ciudadanos y ciudadanas del Perú tenemos derechos y deberes.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="12" color="blue" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="DERECHOS Y DEBERES DE LOS CIUDADANOS" color="blue" />
        <p>
          Todos los ciudadanos y ciudadanas del Perú tenemos derechos y deberes.
          Estos están descritos y explicados en la Constitución Política del
          Perú y en las leyes, y se orientan a promover la realización de las
          personas que son parte de la sociedad.
        </p>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={8}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <div className={classes.rectangleYellow}>
              <h3>TENEMOS DERECHOS:</h3>
              <p>
                Significa que debemos tener acceso a ciertas cosas sin
                restricciones y en igualdad. Por ejemplo, todos tenemos derecho
                a recibir amor, a tener un nombre, a la alimentación, a la
                salud, a la protección, a la educación, a la recreación y muchos
                otros.
              </p>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <div className={classes.rectangleGreen}>
              <h3>TENEMOS DEBERES:</h3>
              <p>
                Significa que estamos en la obligación de hacer ciertas cosas y
                cumplir lo que indican las leyes. Por ejemplo, tenemos el deber
                de respetar los derechos de los demás, de pagar impuestos, entre
                otros.
              </p>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="blue" />
        <p>
          <strong>
            Observa las ilustraciones y completa el espacio indicando si se
            trata de un derecho o un deber.
          </strong>{" "}
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Lamina12act1} alt="Actividad" />
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Lamina12act2} alt="Actividad" />
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Lamina12act3} alt="Actividad" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="DISTINTOS PERO IGUALES ANTE LA LEY" color="blue" />
        <p>
          Cada persona tiene características propias, pero tiene los mismos
          derechos que los demás y merece que estos se respeten, sin distinción
          de sexo, edad, cultura, religión, discapacidad, ni condición social.
          No importa de dónde venimos, cómo somos o cómo hablamos. El Estado
          (gobernantes, leyes, instituciones) debe garantizar nuestros derechos.
        </p>
        <Actividad color="blue" />
        <p>
          <strong>Relaciona las palabras del centro con los personajes.</strong>
          Las palabras de los recuadros grises son algunas de las
          características que hacen particulares a estas personas y las
          distingue de otras.
        </p>
        <Box className={classes.root} display={{ xs: "none", md: "block" }}>
          <img src={ActividadDesktop} alt="Actividad lámina 12" />
        </Box>
        <Box className={classes.root} display={{ xs: "block", md: "none" }}>
          <img src={ActividadMobile} alt="Actividad lámina 12" />
        </Box>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <p>
              <strong>
                Ahora piensa en qué características distinguen a los miembros de
                tu familia y a ti.
              </strong>
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Dialog} alt="Texto" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-12.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.blue }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 12: Derechos y deberes de los ciudadanos'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Los medios de transporte"
        anteriorEnlace="/lamina-1-11"
        siguiente="La identidad y la importancia del DNI"
        siguienteEnlace="/lamina-1-13"
      />
    </>
  );
};

export default Lamina11;
